export enum NOTIFICATION_TAB {
  UPDATE_TAB = 0,
  ORDER_TAB = 1,
}
